import {useLoadMoreSentinel} from "../../../../../../hooks/useLoadMoreSentinel.ts";

interface Props {
    hasMore: boolean;
    isLoadingMore: boolean;
    hasLoadError: boolean;
    onLoadMore: () => void;
    onRetry: () => void;
}

export function InfiniteScrollFooter({hasMore, isLoadingMore, hasLoadError, onLoadMore, onRetry}: Props) {
    const sentinelRef = useLoadMoreSentinel({
        hasMore: hasMore && !hasLoadError,
        isLoadingMore,
        onLoadMore,
    });

    if (hasLoadError) {
        return (
            <div className="flex items-center justify-center gap-3 py-6 text-sm text-gray-500" data-testid="infinite-scroll-error">
                <span>Laden van meer transacties is mislukt.</span>
                <button type="button" onClick={onRetry} className="font-medium text-primary hover:underline">
                    Opnieuw proberen
                </button>
            </div>
        );
    }

    if (!hasMore) {
        return (
            <div className="py-6 text-center text-sm text-gray-400" data-testid="infinite-scroll-end">
                Alle transacties geladen
            </div>
        );
    }

    return (
        <div ref={sentinelRef} className="flex items-center gap-4 px-4 py-3.5" data-testid="infinite-scroll-sentinel">
            <div className="h-8 w-8 shrink-0 animate-pulse rounded-full bg-gray-100"/>
            <div className="space-y-1.5">
                <div className="h-3.5 w-32 animate-pulse rounded bg-gray-100"/>
                <div className="h-3 w-20 animate-pulse rounded bg-gray-100"/>
            </div>
        </div>
    );
}
